import styled from "styled-components"

export const InfoContainer = styled.section`
height: auto;
margin-bottom: 3rem;
/* background: #dedede */

`

export const InfoWrapper = styled.div`
max-width: 1100px;
margin: 0 auto;
margin-top: 3rem;
display:flex;
justify-content: space-evenly;
align-items: center;

@media screen and (max-width: 768px){
    flex-direction: column;
}

`

export const InfoText = styled.div`
margin-top: 2rem;
`

export const InfoHead = styled.h1`
padding-bottom: 5px;
text-align: center;
color: #05386B;
font-size: 3.5rem;
`

export const InfoP = styled.p`
background-color:  #C3073F;
color: #fff;
padding: 8px;
border-radius: 10px;
box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
`